import { requestTool } from "../tools";

const CONTROLLER_URL = "/api/content";

const search = (key) => requestTool.
    getRequest(process.env.REACT_APP_API_URL + CONTROLLER_URL + "?_key=" + key);

const paginate = (data) => requestTool.
    postRequest(process.env.REACT_APP_API_URL + CONTROLLER_URL + "/paginate", data);

export const contentService = {
    search, 
    paginate
};

export default contentService;